"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var getLinking_exports = {};
__export(getLinking_exports, {
  getLinking: () => getLinking,
  normalizeLinkingConfig: () => normalizeLinkingConfig
});
module.exports = __toCommonJS(getLinking_exports);
function getLinking() {
  var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return config;
}
function normalizeLinkingConfig(config) {
  var defaultPrefixes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  var _ref;
  var merged = [
    ...defaultPrefixes,
    ...getSchemePrefixes(config === null || config === void 0 ? void 0 : config.scheme),
    ...(_ref = config === null || config === void 0 ? void 0 : config.prefixes) !== null && _ref !== void 0 ? _ref : []
  ];
  return {
    prefixes: dedupe(merged),
    filter: config === null || config === void 0 ? void 0 : config.filter
  };
}
function getSchemePrefixes(scheme) {
  var schemes = Array.isArray(scheme) ? scheme : scheme ? [
    scheme
  ] : [];
  return schemes.flatMap(function(value) {
    var normalized = value.replace(/:\/+$/, "");
    return [
      `${normalized}://`,
      `${normalized}:///`
    ];
  });
}
function dedupe(values) {
  return [
    ...new Set(values.filter(Boolean))
  ];
}
//# sourceMappingURL=getLinking.js.map
